import { render, staticRenderFns } from "./DanishKeyboard.vue?vue&type=template&id=1534c6cb&"
import script from "./DanishKeyboard.vue?vue&type=script&lang=ts&"
export * from "./DanishKeyboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports